import { Routes, Route } from "react-router-dom";
import WithAuthorization from "./WithAuthorization";
import WithoutAuthorization from "./WithoutAuthorization";
import DashboardLayout from "../components/layouts/Dashboard";
import AuthLayout from "../components/layouts/Auth";
import Login from "../pages/auth/Login";
import Logout from "../pages/auth/Logout";
import Dashboard from "../pages/Dashboard";
import Lists from "../pages/Lists";
import ListDetail from "../pages/ListDetail";
import Campaigns from "../pages/Campaigns";
import CampaignDetail from "../pages/CampaignDetail";
import CampaignInfluencer from "../pages/CampaignInfluencer";
import Brands from "../pages/Brands";
import BrandDetail from "../pages/BrandDetail";
import Agencies from "../pages/Agencies";
import Profiles from "../pages/Profiles";
import AgencyDetail from "../pages/AgencyDetail";
import Settings from "../pages/Settings";
import Profile from "../pages/Profile";
import Invitation from "../pages/auth/Invitation";
import CampaignView from "../pages/CampaignView";
import Notifications from "../pages/Notifications";
import Performance from "../pages/Performance";
import NotFound from "./NotFound";

const AppRoutes = () => (
  <Routes>
    <Route element={<WithoutAuthorization />}>
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/invite" element={<Invitation />} />
      </Route>
    </Route>

    <Route element={<WithAuthorization />}>
      <Route element={<DashboardLayout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/lists" element={<Lists />} />
        <Route path="/lists/:id" element={<ListDetail />} />
        <Route path="/campaigns" element={<Campaigns />} />
        <Route path="/campaigns/:id" element={<CampaignDetail />} />
        <Route path="/campaigns/:id/view" element={<CampaignView />} />
        <Route path="/campaigns/:id/:influencerId" element={<CampaignInfluencer />} />
        <Route path="/brands" element={<Brands />} />
        <Route path="/brands/:id" element={<BrandDetail />} />
        <Route path="/agencies" element={<Agencies />} />
        <Route path="/virtual-managers" element={<Profiles />} />
        <Route path="/agencies/:id" element={<AgencyDetail />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/performance" element={<Performance />} />
      </Route>
    </Route>

    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRoutes;
